import { useEffect } from 'react';

import LoginForm from 'pages/users/Login/components/LoginForm/LoginForm';

import useAppSelector from 'hooks/useAppSelector';
import useNavigateToPrev from 'hooks/useNavigateToPrev';

function Login() {
  const navigateToPrev = useNavigateToPrev();
  const { authenticated } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (authenticated) navigateToPrev();
  }, [authenticated, navigateToPrev]);

  return <LoginForm />;
}

export default Login;
